import NotificationTypes from '../../models/types/NotificationTypes';

import { toast } from 'react-toastify';
import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';

export const notify = (message: any, notificationType: NotificationTypes = NotificationTypes.Success) => {
    const content = (
        <span>
            <FaCheckCircle className="inline mr-2 align-baseline text-green-500" />
            <span className="font-semibold">{String(message)}</span>
        </span>
    );

    switch (notificationType) {
        case NotificationTypes.Success: {
            toast.dark(content, {
                className: 'rounded-md bg-gray-600',
                progressClassName: 'bg-green-500',
            });
            break;
        }
        case NotificationTypes.Info: {
            toast.info(content);
            break;
        }
        case NotificationTypes.Error: {
            toast.error(content);
            break;
        }
        case NotificationTypes.Warning: {
            toast.warning(content);
            break;
        }
    }
};
